/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
import React, { useState } from "react";
import GridItem from "../components/Grid/GridItem.jsx";
import GridContainer from "../components/Grid/GridContainer.jsx";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import awsConfigSettings from "../aws-exports";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import { spinnerService } from "@chevtek/react-spinners";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const UserManagement = () => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [searchUser, setSearchUser] = useState("");
  const [errs, setErrs] = useState({
    search: "",
    email: "",
    phone: ""
  });
  const [user, setUser] = useState(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [password, setPassword] = useState({
    value: "",
    isValid: true,
    err: ""
  });
  const [cpassword, setCpassword] = useState({
    value: "",
    isValid: true,
    err: ""
  });
  const [info, setInfo] = useState({
    enable: false,
    username: "",
    status: "",
    email: "",
    emailVerified: false,
    phone: "",
    phoneVerified: false
  });
  const [tempInfo, setTempInfo] = useState({
    enable: false,
    username: "",
    status: "",
    email: "",
    emailVerified: false,
    phone: "",
    phoneVerified: false
  });
  let userPoolId = {};
  let credentials = {};
  let client = {};

  const getCognitoObjects = async () => {
    userPoolId = awsConfigSettings.aws_user_pools_id;
    credentials = await Auth.currentCredentials();
    client = await Promise.resolve(
      new CognitoIdentityServiceProvider({
        apiVersion: "2016-04-18",
        credentials: Auth.essentialCredentials(credentials),
        region: "us-east-2"
      })
    );
  };

  const enableDisableUser = async flag => {
    spinnerService.show("mySpinner");
    try {
      await getCognitoObjects();
      let params = {
        UserPoolId: userPoolId /* required */,
        Username: info.username /* required */
      };
      if (flag === "d") {
        await client.adminDisableUser(params, function(err, data) {
          if (data !== null && err === null) {
            toast.warn("User Disabled");
          } else {
            toast.err("Disabling User Failed");
          }
        });
      } else if (flag === "e") {
        await client.adminEnableUser(params, function(err, data) {
          if (data !== null && err === null) {
            toast.success("User Enabled");
          } else {
            toast.err("Enabling User Failed");
          }
          handleSearchUser();
          setShowStatusDialog(false);
          spinnerService.hide("mySpinner");
        });
      }
      handleSearchUser();
      setShowStatusDialog(false);
      spinnerService.hide("mySpinner");
    } catch (err) {
      toast.err("An Error Occured, Try Again");
      spinnerService.hide("mySpinner");
    }
  };

  const handleSearchUser = async () => {
    // e.preventDefault();
    await getCognitoObjects();
    spinnerService.show("mySpinner");
    if (["", null, undefined].includes(searchUser)) {
      setErrs({
        ...errs,
        search: "Enter User Name To Search"
      });
      spinnerService.hide("mySpinner");
      return;
    } else {
      try {
        setUser(null);
        let params = {
          UserPoolId: userPoolId /* required */,
          Username: searchUser /* required */
        };
        await client.adminGetUser(params, function(err, data) {
          if (data !== null && err === null) {
            let userObj = {
              username: data.Username,
              status: data.UserStatus,
              enable: data.Enabled
            };
            data.UserAttributes.map(dt => {
              if (
                dt.Name === "email" &&
                !["", null, undefined].includes(dt.Value)
              ) {
                userObj.email = dt.Value;
              }
              if (
                dt.Name === "phone_number" &&
                !["", null, undefined].includes(dt.Value)
              ) {
                userObj.phone = dt.Value;
              }
              if (dt.Name === "phone_number_verified") {
                userObj.phoneVerified = dt.Value;
              }
              if (dt.Name === "email_verified") {
                userObj.emailVerified = dt.Value;
              }
            });
            setInfo({
              ...info,
              enable: userObj.enable,
              username: userObj.username,
              status: userObj.status,
              email: userObj.email ? userObj.email : "",
              phone: userObj.phone ? userObj.phone : "",
              emailVerified: userObj.emailVerified === "true" ? true : false,
              phoneVerified: userObj.phoneVerified === "true" ? true : false
            });
            setTempInfo({
              ...tempInfo,
              enable: userObj.enable,
              username: userObj.username,
              status: userObj.status,
              email: userObj.email ? userObj.email : "",
              phone: userObj.phone ? userObj.phone : "",
              emailVerified: userObj.emailVerified === "true" ? true : false,
              phoneVerified: userObj.phoneVerified === "true" ? true : false
            });
            setUser(userObj);
          } else {
            toast.error("No Such User Exists");
          }
          spinnerService.hide("mySpinner");
        });
      } catch (err) {
        toast.error(err);
        spinnerService.hide("mySpinner");
      }
    }
  };

  const submitChanges = async () => {
    spinnerService.show("mySpinner");
    const { email, emailVerified, phone, phoneVerified, username } = tempInfo;
    // if (
    //   (["", null, undefined].includes(email) ||
    //     !re.test(email.toLowerCase())) &&
    //   !forceSubmit
    // ) {
    //   setErrs({
    //     ...errs,
    //     email: "Email Not Valid (Cannot be Verified)"
    //   });
    //   setForceSubmit(true);
    //   spinnerService.hide("mySpinner");
    //   return;
    // }
    if (["", null, undefined].includes(phone) || phone.length < 10) {
      setErrs({
        ...errs,
        phone: "Phone Number Not Valid (Cannot be Verified)"
      });
      //   setForceSubmit(true);
      spinnerService.hide("mySpinner");
      return;
    } else
      try {
        await getCognitoObjects();
        let params = {
          UserAttributes: [
            {
              Name: "email" /* required */,
              Value: ["", null, undefined].includes(email) ? "" : email
            },
            {
              Name: "phone_number" /* required */,
              Value: ["", null, undefined].includes(phone) ? "" : phone
            },
            {
              Name: "phone_number_verified" /* required */,
              Value:
                phoneVerified || phoneVerified === "true" ? "true" : "false"
            },
            {
              Name: "email_verified" /* required */,
              Value:
                emailVerified || emailVerified === "true" ? "true" : "false"
            }
          ],
          UserPoolId: userPoolId /* required */,
          Username: username /* required */
        };
        await client.adminUpdateUserAttributes(params, function(err, data) {
          if (data !== null && err === null) {
            setTempInfo({
              username: "",
              status: "",
              email: "",
              emailVerified: false,
              phone: "",
              phoneVerified: false
            });
            // setForceSubmit(false);
            setShowEditDialog(false);
            handleSearchUser();
            toast.success("User Updated!");
          } else {
            setErrs({
              ...errs,
              phone: "Phone Number is Required"
            });
            toast.error("An Error Occurred. Try Again!");
          }
          spinnerService.hide("mySpinner");
        });
      } catch (err) {
        toast.error(err);
        spinnerService.hide("mySpinner");
      }
  };

  const RenderEditDialog = (
    <Dialog
      open={showEditDialog}
      onClose={() => setShowEditDialog(false)}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        Edit User : {tempInfo.username}
      </DialogTitle>
      <DialogContent>
        <GridContainer>
          <GridItem xs={12} sm={6}>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Email Address"
              type="email"
              error={errs.email}
              helperText={errs.email}
              value={tempInfo.email}
              onChange={e => {
                setTempInfo({
                  ...tempInfo,
                  email: e.target.value,
                  emailVerified: false
                });
                setErrs({
                  ...errs,
                  email: ""
                });
              }}
            />
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!re.test(tempInfo.email.toLowerCase())}
                    checked={tempInfo.emailVerified}
                    onChange={e => {
                      if (re.test(tempInfo.email.toLowerCase())) {
                        setTempInfo({
                          ...tempInfo,
                          emailVerified: e.target.checked
                        });
                      } else {
                        setTempInfo({
                          ...tempInfo,
                          emailVerified: false
                        });
                      }
                    }}
                    value={tempInfo.emailVerified}
                  />
                }
                label="Mark as Verified"
              />
            </FormGroup>
          </GridItem>
          <GridItem xs={12} sm={6}>
            <TextField
              autoFocus
              required={true}
              margin="dense"
              id="phone"
              label="Phone Number"
              placeholder="+1(541) 754-3010"
              type="tel"
              error={errs.phone}
              helperText={errs.phone}
              value={tempInfo.phone}
              onChange={e => {
                setTempInfo({
                  ...tempInfo,
                  phone: e.target.value,
                  phoneVerified: false
                });
                setErrs({
                  ...errs,
                  phone: ""
                });
              }}
            />
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={tempInfo.phone.length < 10}
                    checked={tempInfo.phoneVerified}
                    onChange={e => {
                      if (tempInfo.phone.length >= 10) {
                        setTempInfo({
                          ...tempInfo,
                          phoneVerified: e.target.checked
                        });
                      } else {
                        setTempInfo({
                          ...tempInfo,
                          phoneVerified: false
                        });
                      }
                    }}
                    value={tempInfo.phoneVerified}
                  />
                }
                label="Mark as Verified"
              />
            </FormGroup>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setTempInfo(info);
            setShowEditDialog(false);
            // setForceSubmit(false);
            setErrs({
              ...errs,
              phone: "",
              email: ""
            });
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button onClick={submitChanges} color="primary">
          Submit Changes
        </Button>
      </DialogActions>
    </Dialog>
  );

  const RenderDisableDialog = (
    <Dialog
      open={showStatusDialog}
      onClose={() => setShowStatusDialog(false)}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {info.enable ? "Disable User :" : " Enable User :"} {tempInfo.username}
      </DialogTitle>
      <DialogActions>
        <Button onClick={() => setShowStatusDialog(false)} color="primary">
          No
        </Button>
        {info.enable ? (
          <Button onClick={() => enableDisableUser("d")} color="primary">
            Yes
          </Button>
        ) : (
          <Button onClick={() => enableDisableUser("e")} color="primary">
            Yes
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );

  const submitCheck = (id, value) => {
    
    if (["", null, undefined].includes(value) || value.length <= 0) {
      if (id === "password") {
        setPassword({
          value,
          isValid: false,
          err: "This Field is Required"
        });
      } else if (id === "cpassword") {
        setCpassword({
          value,
          isValid: false,
          err: "This Field is Required"
        });
      }
    } else {
      if (id === "password" && value.length < 6) {
        setPassword({
          value,
          isValid: false,
          err: "Password Must be 6 Characters Atleast"
        });
      } else if (id === "cpassword" && value !== password.value) {
        setCpassword({
          value,
          isValid: false,
          err: "Password Didn't Match"
        });
      }
    }
  };

  const updatePassword = async e => {
    
    e.preventDefault();
    if (["", null, undefined].includes(password.value) || !password.isValid) {
      submitCheck("password", password.value);
      
      return;
    } else if (
      ["", null, undefined].includes(cpassword.value) ||
      !cpassword.isValid || cpassword.value !== password.value
    ) {
      submitCheck("cpassword", cpassword.value);
      return;
    } else {
      try {
        
        let pass = password.value;
        spinnerService.show("mySpinner");
        let userPoolId = awsConfigSettings.aws_user_pools_id;
        let credentials = await Auth.currentCredentials();
        let client = await Promise.resolve(
          new CognitoIdentityServiceProvider({
            apiVersion: "2016-04-18",
            credentials: Auth.essentialCredentials(credentials),
            region: "us-east-2"
          })
        );
        var params = {
          UserPoolId: userPoolId /* required */,
          Password: pass,
          Username: info.username /* required */,
          Permanent: true
        };
        await client.adminSetUserPassword(params, function(err, data) {
          if (data !== null && err === null) {
            
            spinnerService.hide("mySpinner");
            toast.success("Password Changed");
          } else {
            
            spinnerService.hide("mySpinner");
            toast.error("Password Not Changed");
          }
        });
        setPasswordDialog(false);
        setPassword({
          value: "",
          isValid: true,
          err: ""
        });
        setCpassword({
          value: "",
          isValid: true,
          err: ""
        });
      } catch (err) {
        spinnerService.hide("mySpinner");
        
        toast.error(err.message);
      }
    }
  };

  const changePassword = e => {
    const { id, value } = e.target;
    if (id === "password") {
      setPassword({
        value,
        isValid: true,
        err: ""
      });
    } else if (id === "cpassword") {
      setCpassword({
        value,
        isValid: true,
        err: ""
      });
    }
  };

  const checkPassword = e => {
    const { id, value } = e.target;
    if (["", null, undefined].includes(value) || value.length <= 0) {
      if (id === "password") {
        setPassword({
          value,
          isValid: false,
          err: "This Field is Required"
        });
      } else if (id === "cpassword") {
        setCpassword({
          value,
          isValid: false,
          err: "This Field is Required"
        });
      }
    } else {
      if (id === "_password" && value.length < 6) {
        setPassword({
          value,
          isValid: false,
          err: "Password Must be 6 Characters Atleast"
        });
      } else if (id === "_cPassword" && value !== password.value) {
        setCpassword({
          value,
          isValid: false,
          err: "Password Didn't Match"
        });
      }
    }
  };

  const RenderPasswordDialog = (
    <Dialog
      open={passwordDialog}
      onClose={() => setPasswordDialog(false)}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
      <DialogContent>
        <TextField
          value={password.value}
          onChange={changePassword}
          onBlur={checkPassword}
          margin="dense"
          id="password"
          label="New Password"
          error={!password.isValid}
          helperText={password.err}
          type="password"
        />
        <TextField
          value={cpassword.value}
          onChange={changePassword}
          onBlur={checkPassword}
          margin="dense"
          id="cpassword"
          label="Confirm New Password"
          error={!cpassword.isValid}
          helperText={cpassword.err}
          type="password"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPasswordDialog(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={updatePassword} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
  return (
    <React.Fragment>
      {RenderEditDialog}
      {RenderDisableDialog}
      {RenderPasswordDialog}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {/* <Router> */}
          <div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap"
              }}
            >
              <TextField
                id="searchUser"
                label="Search User"
                style={{
                  width: 200
                }}
                // onEnded={handleSearchUser}
                error={errs.search}
                helperText={errs.search}
                value={searchUser}
                onChange={e => {
                  
                  setSearchUser(e.target.value);
                  }}
                margin="normal"
              />
              <Button variant="contained" onClick={handleSearchUser}>
                Search
              </Button>
            </div>
          </div>
          <div style={{ float: "left", padding: "10px" }}></div>
          <Card>
            <CardHeader>
              {user !== null && (
                <div>
                  <h3>User Info</h3>
                </div>
              )}
            </CardHeader>
            <CardBody style={{ minHeight: 585 }}>
              {user !== null && (
                <Table
                  padding="checkbox"
                  style={{
                    minWidth: 500
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>User Name</TableCell>
                      <TableCell align="right">Status</TableCell>
                      <TableCell align="right">Email</TableCell>
                      <TableCell align="right">Phone</TableCell>
                      <TableCell align="right" />
                      <TableCell align="right" />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {info.username}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: info.enable ? "green" : "red"
                        }}
                      >
                        {info.enable ? "Enabled" : "Disabled"}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: info.emailVerified ? "green" : "red"
                        }}
                      >
                        {info.email}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color: info.phoneVerified ? "green" : "red"
                        }}
                      >
                        {info.phone}
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          style={{ color: "purple", cursor: "pointer" }}
                          onClick={() => setShowEditDialog(true)}
                        >
                          Edit
                        </Typography>
                      </TableCell>
                      <TableCell
                        style={{ color: "purple", cursor: "pointer" }}
                        align="right"
                        onClick={() => setShowStatusDialog(true)}
                      >
                        {info.enable ? "Disable" : "Enable"}
                      </TableCell>
                      <TableCell>
                        <Button
                          color="info"
                          onClick={() => setPasswordDialog(true)}
                        >
                          Change Password
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </React.Fragment>
  );
};

export default UserManagement;



// WEBPACK FOOTER //
// ./src/admin/UserManagement.js